import { PlasFacet, PlasFacetTerm } from "@biblioteksentralen/bmdb-search-client";
import { FormControl, HStack, Link, VStack } from "@biblioteksentralen/react";
import { useSearchContext } from "./SearchContext";
import FilterTags from "../../../components/filter/FilterTags";
import { FilterOption } from "../../../components/filter/useFilter";
import { useTranslation } from "../../../utils/hooks/useTranslation";
import WorkSearchFacets from "./WorkSearchFacets";
import { allSearchFacets, WorkSearchFacet } from "./types";
import { useFacetAndFilterContext } from "./FacetAndFilterContext";

const WorkSearchFilters = () => {
  const { searchState, setSearchState } = useSearchContext();
  const { clearFacetCaches, currentFacetsInUse } = useFacetAndFilterContext();
  const { t } = useTranslation();

  const currentTerms = currentFacetsInUse?.flatMap((facet) =>
    facet.terms.map((term) => ({ value: term.value, name: term.name }))
  );

  const onChange = (checked: boolean, facet: PlasFacet, term: PlasFacetTerm) => {
    const workFiltersForFacet = searchState?.work?.[facet.type as WorkSearchFacet] ?? [];
    const termExistsInWorkFilters = workFiltersForFacet?.includes(term.value);
    const newWorkFiltersForFacet = checked
      ? [...(workFiltersForFacet ?? []), ...(termExistsInWorkFilters ? [] : [term.value])]
      : workFiltersForFacet.filter((filter) => filter !== term.value);

    const newWorkSearchState = {
      [facet.type as WorkSearchFacet]: newWorkFiltersForFacet,
    };

    setSearchState({
      work: { ...newWorkSearchState, pagination: undefined },
    });
  };

  const onTagUpdate = (filterOption: FilterOption) => {
    clearFacetCaches();
    const facetToUpdate = allSearchFacets.find((searchFacet) =>
      searchState?.work?.[searchFacet]?.includes(filterOption.key)
    );
    const updatedFacetTerms =
      facetToUpdate && searchState?.work?.[facetToUpdate]?.filter((term) => term !== filterOption.key);

    const newWorkSearchState = facetToUpdate && {
      [facetToUpdate]: updatedFacetTerms,
    };

    setSearchState({
      work: { ...newWorkSearchState, pagination: undefined },
    });
  };

  return (
    <FormControl as={VStack} gap="1rem">
      <WorkSearchFacets onChange={onChange} />
      {currentTerms && currentTerms.length > 0 && (
        <HStack gap="1rem" width="100%" alignItems="flex-start">
          <FilterTags
            onTagUpdate={onTagUpdate}
            items={currentTerms?.map((term) => ({ key: term.value, value: term.name }))}
          />
          <Link
            as="button"
            onClick={() => {
              clearFacetCaches();
              setSearchState({
                work: {
                  ...allSearchFacets.reduce((acc, searchFacet) => ({ ...acc, [searchFacet]: undefined }), {}),
                },
              });
            }}
          >
            {t("Fjern filtre")}
          </Link>
        </HStack>
      )}
    </FormControl>
  );
};

export default WorkSearchFilters;
